import {
	Form,
	FormItem,
	Select,
	SelectItem,
	Toolbar
} from "client/Components";
import { FilterValueState } from "client/Hooks/useFilterHandler";
import { ReactElement, useState } from "react";
import { localize } from "client_legacy/ndaw/culture";

export type FilterFormProps<T> = {
	filterable: FilterValueState<T | null>;
	onClose(): void;
	statusFilterOptions: readonly SelectItem<T>[];
};

export const FilterForm = <T extends unknown>(
	props: FilterFormProps<T>
): ReactElement => {
	const {
		filterable,
		onClose,
		statusFilterOptions
	} = props;

	const {
		value,
		setValue
	} = filterable;

	const [pickedStatus, setPickedStatus] = useState<T | null>(value);

	const filterHandler = (): void => {
		setValue(pickedStatus);
		onClose();
	};

	const clearHandler = (): void => {
		setPickedStatus(null);
		setValue(null);
	};

	return (
		<Form onSubmit={filterHandler}>
			<FormItem label={localize("_GridFilterMenuTitle")}>
				<Select
					value={pickedStatus}
					onChange={setPickedStatus}
					options={statusFilterOptions}
					trackingId="status-select"
					menuTitle={localize("_GridFilterMenuTitle")}
				/>
			</FormItem>
			<div>
				<Toolbar horizontalAlignment="right">
					<Toolbar.Button
						kind="primary"
						text={localize("_Filter")}
						onClick={filterHandler}
						trackingId="filter-button"
					/>
					<Toolbar.Button
						kind="secondary"
						text={localize("_Clear")}
						onClick={clearHandler}
						trackingId="clear-button"
					/>
				</Toolbar>
			</div>
		</Form>
	);
};

FilterForm.displayName = "TableView.DefaultColumnFilterableForm";

